import { useGetStreamingUrlQuery, useGetFileQuery } from 'services'

export const useRenderFile = ({ id, data, filesCount }) => {
    const obj = { data: undefined, isFetching: false, error: undefined }

    const video = useGetStreamingUrlQuery(
        { id, isShareeView: Boolean(data?.isShared) },
        {
            skip: !filesCount || data.fileType !== 'video',
            refetchOnMountOrArgChange: true,
        }
    )
    const image = useGetFileQuery(
        { id, query: data?.isShared ? '&IsSharedView=true' : '' },
        {
            skip: !filesCount || data.fileType !== 'image',
        }
    )

    if (data.fileType === 'video') return video
    else if (data.fileType === 'image') return image
    else return obj
}
